module.exports = __webpack_public_path__ + "img/favorite_33d03.png";